export default {
  title: '好大夫教育网-医学教育网',
  baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:8000',
  apiUrl: process.env.VUE_APP_API_URL || '/api',
  timeout: 10000
}
